import { useBuyerNavigationLayoutContext } from '@/enterprise/components/BuyerNavigationLayout';
import LegacyIneligibleInvoices from '@/enterprise/features/ineligibleInvoiceTable/LegacyIneligibleInvoices';
import { IneligibleInvoicesView } from '@/enterprise/features/invoiceTables/ineligible';
import useFeature from '@/lib/features';
import { useReporting } from '@/reporting';

/**
 * Division Details → Ineligible.
 * FF off: Node legacy table. FF on: shared SEA locked-invoice view (IC parity)
 * with filter-bar SEA locked CSV (all / filtered).
 */
const IneligibleInvoices = () => {
  const [invoiceApiMigrationEnabled] = useFeature('enterprise-ui_invoiceApiMigration');
  const { trackEnterpriseEvent } = useReporting();
  const { buyer, takerMarket, urlParams } = useBuyerNavigationLayoutContext();

  if (!invoiceApiMigrationEnabled) {
    return <LegacyIneligibleInvoices />;
  }

  return (
    <IneligibleInvoicesView
      source={{
        makerOrganizationUuid: urlParams.makerOrganizationUuid,
        makerOrganizationName: buyer.makerOrganizationName,
        currency: takerMarket.currency,
        takerMarkets: [takerMarket],
        divisionId: urlParams.takerId,
      }}
      actions={{
        enableFilterBarDownload: true,
        onDownloadSubmitted: ({ scope }) => {
          trackEnterpriseEvent('invoice-download::submitted', {
            invoiceType: 'ineligible',
            downloadScope: scope,
            takerId: urlParams.takerId,
            marketId: urlParams.marketId,
          });
        },
        onSearch: ({ searchValue }) => {
          trackEnterpriseEvent('invoice-search::submitted', { searchValue });
        },
        onSort: ({ sortKey, sortDirection }) => {
          trackEnterpriseEvent('invoice-sort::clicked', { key: sortKey, direction: sortDirection });
        },
        onFiltersChange: ({ filterKeys }) => {
          trackEnterpriseEvent('invoice-filter::clicked', { keys: filterKeys });
        },
        onPageChange: () => {
          trackEnterpriseEvent('invoice-page::clicked');
        },
        onPageSizeChange: ({ size }) => {
          trackEnterpriseEvent('invoice-page-size::clicked', { size });
        },
      }}
    />
  );
};

export default IneligibleInvoices;
